import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X, Calendar } from "lucide-react";

const PlanGoWidget = () => {
  const [isMinimized, setIsMinimized] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMinimized(false);
    }, 7000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (document.getElementById("plango-widget-script")) return;

      (window as any).PlanGoWidget = {
        identifier: "rijschool-de-diamant",
      };

      const script = document.createElement("script");
      script.id = "plango-widget-script";
      script.src = "https://plangoapp.nl/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const widgetUI = (
    <>
      {isMinimized && (
        <style>
          {`
            #plango, #plango-widget-container, .plango-widget, div[id^="plango"], iframe[src*="plangoapp.nl"] {
              display: none !important;
              opacity: 0 !important;
              pointer-events: none !important;
              visibility: hidden !important;
            }
          `}
        </style>
      )}

      {!isMinimized && (
        <button
          onClick={() => setIsMinimized(true)}
          className="fixed z-[2147483647] bg-slate-900 text-white rounded-full border-2 border-white flex items-center justify-center shadow-md cursor-pointer hover:bg-slate-800 transition-colors pointer-events-auto"
          style={{
            width: "28px",
            height: "28px",
            bottom: "85px",
            right: "15px",
          }}
          aria-label="Sluit inschrijven"
        >
          <X size={16} strokeWidth={3} />
        </button>
      )}

      {isMinimized && (
        <button
          onClick={() => setIsMinimized(false)}
          className="fixed z-[2147483647] bg-[#38bdf8] text-white rounded-full flex items-center justify-center shadow-lg cursor-pointer hover:scale-110 transition-transform pointer-events-auto"
          style={{
            width: "32px",
            height: "32px",
            bottom: "20px",
            right: "20px",
          }}
          aria-label="Open inschrijven"
        >
          <Calendar size={16} strokeWidth={2} />
        </button>
      )}
    </>
  );

  return typeof document !== "undefined"
    ? createPortal(widgetUI, document.body)
    : null;
};

export default PlanGoWidget;
